import React, { useContext } from 'react';
import { toast } from 'react-toastify';
import { MessageContext } from '../locale/MessageProvider';
import { StatusMessage } from 'is24-corecss';

const StatusMessageWrapper: React.FC<Toast> = (toast: Toast) => {
  const messageFormatter = useContext(MessageContext);
  return (
    <StatusMessage
      statusStyle="toast"
      headline={messageFormatter.formatHttpMessage(toast.head)}
      message={messageFormatter.formatHttpMessage(toast.message)}
      statusType={toast.type}
    />
  );
};

type Toast = {
  head: string;
  message: string;
  type: StatusType;
};

enum StatusType {
  info = 'info',
  confirm = 'confirm',
  error = 'error',
}

const _popMessage = (toast2: Toast) => {
  toast(() => <StatusMessageWrapper message={toast2.message} head={toast2.head} type={toast2.type} />);
};

const toastService = {
  popMessage: _popMessage,
  toastType: StatusType,
};

export default toastService;
